<app-header></app-header>
<div class="container-fluid py-20 bg-pricing-plan">
  <div class="container">
    <p class="pt-8 text-4xl text-center font-bold text-white">Simple, transparent pricing.</p>
    <p class="text-2xl text-center text-white pt-4">Always know what you'll pay</p>
    <p class="text-2xl text-center text-white pt-4">Choose an affordable plan that's packed with the best features for
      engaging your driving sales.</p>
  </div>
</div>

<!--<div class="container-fluid p-8 mt-10 md:mt-20" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="flex flex-wrap gap-4" [style.font-family]="'var(&#45;&#45;vex-font)'">
      <div class="p-8 w-full border md:w-[32%] border border-gray-300 relative rounded-2xl py-20"
           *ngFor="let planType of finalPlans; let i = index" [ngClass]="{'border-purple-800': i === 1}">
        <div *ngIf="i===1"
             class="bg-[#6752A9] mt-4 px-3 md:px-8 py-4 font-bold left text-white rounded-3xl absolute whitespace-nowrap"
             [style.font-family]="'var(&#45;&#45;vex-font)'" style="left: 50%; transform: translateX(-50%);">
          Most Popular
        </div>
        <h2 class="text-3xl font-bold mb-4">{{ planType.type | titlecase }} plan</h2>
        <div *ngIf="planType.plans">
          <div *ngFor="let plan of planType.plans;">
            <div class="mt-4" *ngIf="plan.status == true;">
              <p class="text-gray-500 text-lg font-medium mt-2">{{ plan.overview }}</p>
            </div>
          </div>
        </div>
        <form [formGroup]="planForm" class="py-6" [style.font-family]="'var(&#45;&#45;vex-font)'">
          <mat-select class="toolbar-select-option" #event [style.font-family]="'var(&#45;&#45;vex-font)'"
                      (selectionChange)="onChange(planType.type,event.value)"
                      formControlName="selectedPlan" placeholder="Select plan">
            <mat-option *ngFor="let plan of planType.plans" [value]="plan.overview">
              {{ plan.overview }}
            </mat-option>
          </mat-select>
        </form>
        <div *ngIf="planType.plans" [style.font-family]="'var(&#45;&#45;vex-font)'">
          <div *ngFor="let plan of planType.plans;">
            <div *ngIf="plan.status == true;">
              <p class="mt-4 text-xl">{{plan?.description}}</p>
              <p class="mt-1 text-xl"><strong>Users : </strong>{{ plan.users }}</p>
              <p class="mt-1 text-xl"><strong>Price : </strong><span
                class="line-through text-red-500">&#8377;{{plan.price | IndianNumber}}/-
                </span></p>
              <p class="mt-1 text-xl"><strong>Discounted Price : </strong> <span
                class="text-green-600">&#8377;{{plan.discounted_price | IndianNumber}}/-</span></p>
              <button *ngIf="(user && (user.user_count <= plan.users)) || !user"
                      class="w-full custom-button mt-12 text-lg p-4 rounded-2xl"
                      (click)="goToCheckOut(plan.plan_id)">
                Pay Now
              </button>
              <button *ngIf="user && (user.user_count > plan.users)"
                      class="w-full custom-button mt-12 text-lg p-4 rounded-2xl cursor-not-allowed opacity-8"
                      matTooltip="You are not allowed to choose this plan" (click)="notAllowed()">
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="flex flex-wrap gap-4" [style.font-family]="'var(--vex-font)'">
      <div class="p-8 w-full border md:w-[32%] border-gray-300 relative rounded-2xl py-14"
           *ngFor="let planType of finalPlans; let i = index"
           [ngClass]="{'bg-light-purple text-dark-purple': selectedPlanType === planType.type, 'bg-white': selectedPlanType !== planType.type}">
        <div *ngIf="i === 1"
             class="bg-[#6752A9]  md:px-8  font-bold left text-white rounded-3xl absolute whitespace-nowrap"
             [style.font-family]="'var(--vex-font)'" style="left: 25%; transform: translateX(-50%);">
          Most Popular
        </div>
        <div class="absolute top-2 right-2">
          <div *ngIf="planType.plans">
            <div *ngFor="let plan of planType.plans">
              <div class="text-gray-700" *ngIf="plan.status == true;">
                <i [ngClass]="[plan.icon_class, getColorClass(plan.overview)]"></i>
                {{ plan.icon_text }}
              </div>
            </div>
          </div>
        </div>
        <h2 class="text-3xl font-bold mb-4 plan-name">{{ planType.type | titlecase }} Plan</h2>
        <form [formGroup]="planForm" class="pt-6 pb-1" [style.font-family]="'var(--vex-font)'">

          <mat-label class="text-[11px] absolute font-semibold text-gray-500" style="top:23.5%; left: 12%">Select Plan
            Duration
          </mat-label>
          <mat-select class="mx-auto pb-10 pt-4 rounded-md toolbar-select-option subheading-2 ps-4 ellipsis-text" #event
                      [style.font-family]="'var(--vex-font)'"
                      (selectionChange)="onChange(planType.type, event.value)"
                      formControlName="selectedPlan" placeholder="Select plan duration">
            <mat-option *ngFor="let plan of planType.plans" [value]="plan.overview">
              {{ plan.overview }}
            </mat-option>
          </mat-select>
        </form>

        <div *ngIf="planType.plans" [style.font-family]="'var(--vex-font)'">
          <div *ngFor="let plan of planType.plans;">
            <div *ngIf="plan.status">

              <p class="mt-3">{{ plan.description }}</p>
              <p class="mt-1 text-xl"><strong class="text-[16px] text-gray-600">Users: </strong>{{ plan.users }}</p>
              <p class="mt-1 text-xl"><strong class="text-[16px] text-gray-600">Price: </strong><span
                class="line-through text-red-500">&#8377;{{ plan.price | IndianNumber }}/-</span></p>
              <p class="mt-1 text-xl"><strong class="text-[16px] text-gray-600">Discounted Price: </strong><span
                class="text-green-600">&#8377;{{ plan.discounted_price | IndianNumber }}/-</span></p>
              <button *ngIf="(user && (user.user_count <= plan.users)) || !user"
                      class="w-full custom-button mt-12 text-lg p-4 rounded-2xl"
                      (click)="goToCheckOut(plan.plan_id)">
                Pay Now
              </button>
              <button *ngIf="user && (user.user_count > plan.users)"
                      class="w-full custom-button mt-12 text-lg p-4 rounded-2xl cursor-not-allowed opacity-8"
                      matTooltip="You are not allowed to choose this plan" (click)="notAllowed()">
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <p class="mx-auto text-gray-600 text-[12px]"><strong>Note : </strong>Please note that all of our pricing plans are based on user accounts, and student admissions are not included in this count. Student admissions are unlimited and do not contribute to the number of user accounts in any plan.</p>
    </div>
  </div>
</div>
<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container mx-auto py-8 ">
    <p class="text-5xl text-center font-semibold">Comparing Pricing and Plans</p>
    <div class="overflow-x-auto mt-12">
      <table class="table-auto w-full border-collapse border border-gray-200 shadow-md bg-white rounded-lg">
        <thead class="purple-color">
        <tr>
          <th class="px-6 py-3 border-b border-gray-200">
            <div class="text-2xl font-semibold text-center">Functionalities</div>
          </th>
          <th class="px-6 py-3 border-b border-gray-200">
            <div class="text-2xl font-semibold text-center">Basic</div>
          </th>
          <th class="px-6 py-3 border-b border-gray-200">
            <div class="text-2xl font-semibold text-center">Standard</div>
          </th>
          <th class="px-6 py-3 border-b border-gray-200">
            <div class="text-2xl font-semibold text-center">Premium</div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr class="border-b border-gray-200 bg-gray-100">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Multi-Institution Management</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>Add Multiple Institutions : Effortlessly manage multiple institutions from a single platform.</li>
                <li>Institutions Support : Comprehensive support for managing institution-specific needs.</li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Admin Management</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>
                  Add Multiple Admins : Appoint multiple administrators to oversee operations.
                </li>
                <li>
                  Admins Support : Robust support for admin-related functionalities.
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200 bg-gray-100">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Head Counselor Management</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>
                  Add Multiple Head Counselors: Designate multiple head counselors to lead teams.
                </li>
                <li>
                  Head Counselors Support: Full support for head counselor functionalities.
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Counselor Management</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>
                  Add Multiple Counselors : Incorporate multiple counselors for streamlined operations.
                </li>
                <li>
                  Multiple Counselors Support : Dedicated support for managing counselor roles.
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200 bg-gray-100">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Counselor Management</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>
                  Institute-wise Session Support : Tailor sessions according to specific institutional needs.
                </li>
                <li>
                  Program Addition : Easily add and manage new programs.
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Course and Branch Management</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>
                  Course Addition : Seamlessly add new courses to the system.
                </li>
                <li>
                  Branch Addition: Expand and manage different branches effectively.
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200 bg-gray-100">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Mapping and Follow-Up Management</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>Mappings : Efficiently map courses, programs, and branches.</li>
                <li>
                  <div>
                    <p class="font-semibold text-xl">Follow-Up Management</p>
                    <ul class="list-disc text-md text-zinc-700 ml-4">
                      <li>Stage Creation for Follow-Ups : Create and manage various follow-up stages.
                      </li>
                      <li>Reason Creation for Follow-Ups : Define reasons for follow-ups to maintain clarity.
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Lead Management System</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>Easy Integration with Lead Management System : Simplified integration process for lead management
                  systems
                </li>
                <li>Integration Support for Lead Management System : Comprehensive support for lead management system
                  integration.
                </li>
                <li>Manual Lead Management : Manage leads manually with ease.</li>
                <li>Online Lead Management : Automate lead management through online systems.
                  <ul class="list-disc text-md text-zinc-700 ml-4 pt-1 pb-3">
                    <li>Add Manual Leads : Enter leads manually into the system.
                    </li>
                    <li>Fetch Leads from Facebook, Messenger & Instagram : Automatically fetch leads from social media
                      platforms.
                    </li>
                    <li>Manual Lead Management : Manage leads manually with ease.</li>
                    <li>Assign Leads to Counselors & Head Counselors : Efficiently assign leads to relevant personnel.
                    </li>
                    <li>Lead Follow-Ups : Ensure timely follow-ups for all leads.</li>
                  </ul>
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200 bg-gray-100">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Student and Accounts Management Systems</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>Student Management System : Comprehensive system for managing student data and interactions.</li>
                <li>Accounts Management System : Robust system for managing financial accounts.
                </li>
                <li>
                  <div>
                    <p class="font-semibold text-xl">Receipts Management System</p>
                    <ul class="list-disc text-md text-zinc-700 ml-4">
                      <li>Upload transaction receipts.
                      </li>
                      <li>Track the status of uploaded receipts.
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Enhanced Features for Premium Plans</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>IVR Integration : Seamless integration with Interactive Voice Response systems, available with
                  separate pricing and plans.
                </li>
                <li>Relationship Manager (RM) Assistance : Dedicated RM support for personalized guidance.
                </li>
                <li>Personalized Assistance : Tailored support to meet your institution's specific needs.
                </li>
                <li>
                  One-Call Answer Support : Instant support available for Premium Plans or Yearly packages.
                </li>
                <li>
                  One-Click Dial Solution : Initiate calls directly from the panel with a single click.
                </li>
                <li>
                  Direct Call to Leads : Facilitate direct communication with leads from the system.
                </li>
                <li>
                  Data Storage and Backup : Secure data storage and backup options, available exclusively in Premium or
                  Yearly packages.
                  <div>
                    <ul class="list-disc text-md text-zinc-700 ml-4">
                      <li>
                        Data Restoration : Free data restoration services included with backup.
                        Upload transaction receipts.
                      </li>
                      <li>
                        Recordings Storage : Store call recordings securely within the system.
                      </li>
                      <li>
                        Anytime Download of Recordings : Access and download call recordings at your convenience.
                      </li>
                      <li>
                        Reporting and Analytics : Comprehensive reporting and analytics for follow-ups, calls, and
                        sales.
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <tr class="border-b border-gray-200 bg-gray-100">
          <td class="px-6 py-4 font-semibold">
            <div>
              <p class="font-semibold text-xl">Additional Features</p>
              <ul class="list-disc text-md text-zinc-700 ml-4">
                <li>
                  Tickets Support : Raise tickets for admission-related or other issues.
                </li>
                <li>
                  Notifications : Stay updated with timely notifications.
                </li>
                <li>
                  Download Excel : Download data in Excel format for ease of use.
                </li>
                <li>
                  Discounts : Avail discounts on yearly subscriptions.

                </li>
                <li>
                  24/7 Support : Access round-the-clock support for any issues.

                </li>
                <li>
                  IVR Integration : Integrate Interactive Voice Response systems (additional charges apply).
                </li>
              </ul>
            </div>
          </td>

          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>
        </tr>
        <!--        <tr class="border-b border-gray-200">-->
        <!--          <td class="px-6 py-4 font-semibold text-xl">Tickets Support-->
        <!--            <p class="text-md text-justify text-zinc-700">You could raise a ticket, against admission</p>-->
        <!--            <p class="text-md text-justify text-zinc-700">related or any other issue also.</p>-->
        <!--          </td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--        </tr>-->
        <!--        <tr class="border-b border-gray-200 bg-gray-100">-->
        <!--          <td class="px-6 py-4 font-semibold text-xl">Notifications</td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--        </tr>-->
        <!--        <tr class="border-b border-gray-200">-->
        <!--          <td class="px-6 py-4 font-semibold text-xl">Download Excel</td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--        </tr>-->
        <!--        <tr class="border-b border-gray-200 bg-gray-100">-->
        <!--          <td class="px-6 py-4 font-semibold text-xl">Discount</td>-->
        <!--          <td class="px-6 py-4 text-center"></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i>-->
        <!--            <p class="text-md">(in yearly subscription only)</p></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--        </tr>-->
        <!--        <tr class="border-b border-gray-200">-->
        <!--          <td class="px-6 py-4 font-semibold text-xl">24/7 Support</td>-->
        <!--          <td class="px-6 py-4 text-center"></td>-->
        <!--          <td class="px-6 py-4 text-center"></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--        </tr>-->
        <!--        <tr class="border-b border-gray-200 bg-gray-100">-->
        <!--          <td class="px-6 py-4 font-semibold">-->
        <!--            <div>-->
        <!--              <p class="font-semibold text-xl">*Additional Features</p>-->
        <!--              <ul class="text-md text-zinc-700 ml-4">-->
        <!--                <li>IVR Integration</li>-->
        <!--              </ul>-->
        <!--              <p class="text-sm">(Additional Charges Applied)</p>-->
        <!--            </div>-->
        <!--          </td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--          <td class="px-6 py-4 text-center"><i class="fa fa-check text-2xl text-green-600"></i></td>-->
        <!--        </tr>-->
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4">
    <div>
      <div class="text-center text-4xl font-extrabold">
        Don't take our word for it.
      </div>
      <div class="text-center text-4xl font-extrabold">Trust our customers</div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mt-8">
      <div class="card p-4" *ngFor="let i of Testimonial">
        <div class="flex items-center gap-0.5">
          <div
            *ngFor="let star of getStarsArray(i.starCount)"
            class="rounded-lg  text-yellow-500 inline-flex items-center justify-center p-0.5">
            <mat-icon class="flex-none icon-xs" svgIcon="mat:star"></mat-icon>
          </div>
        </div>
        <div class="text-gray-700 dark:text-gray-400 mt-3 mb-4">
          {{ i.description }}
        </div>
        <div class="flex items-center gap-3">
          <img class="w-9 h-9 rounded-full" src="{{ i.imageSrc }}"/>
          <div class="space-y-0.5">
            <div class="font-medium text-sm">{{ i.name }}
            </div>
            <div class="font-medium text-sm">- {{ i.designation }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid p-4 mt-10 md:mt-20" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container purple-color p-5 py-8 rounded-2xl">
    <div class="text-5xl font-extrabold drop-shadow-sm max-w-xl mx-auto text-center">
      Bring your productivity to the next level.
    </div>
    <div class="text-gray-200 mt-4 max-w-md mx-auto text-center">
      Explore new horizons and subscribe to a delightful experience you will
      never want to miss.
    </div>
    <div class="flex justify-center">
      <button class="mx-auto mt-6 purple-only bg-white p-2 px-4 rounded-2xl" (click)="goTo('/auth/register')">
        Sign up
      </button>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-40 bg-faq py-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <h2 class="text-center text-4xl font-bold leading-7">
      Frequently Asked Questions
    </h2>
    <div class="flex flex-col md:flex-row justify-between items-center gap-8 pt-12">
      <div class="flex-1 flex-shrink-0">
        <img src="/assets/images/features-images/faq2.jpg" alt="FAQ Image" class="md:w-100 md:h-96 rounded-2xl"/>
      </div>
      <div class="flex-1 flex flex-col">
        <div class="flex-1 flex flex-col md:max-w-xl px-1 md:px-0">
          <mat-accordion class="p-2 flex-1">
            <mat-expansion-panel class="py-8 mb-4 md:py-2 border-solid-purple">
              <mat-expansion-panel-header class="flex items-center">
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                 What is included in the Basic Plan?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 md:pt-0 md:mt-0 text-justify text-zinc-500">
                Our Basic Plan, "Starter Admission Essentials," includes Streamlined Admission Management and limited
                support to help you get started with basic admission processes at a minimal cost.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 mb-4 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
               How do I get a quote for the Premium Plan?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                To receive a custom quote for our "Complete Integration Mastery" Premium Plan, please contact our sales
                team. We will assess your institution's specific needs and provide a tailored pricing package.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 mb-4 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                 Can I upgrade from the Basic Plan to a Standard plan?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Yes, you can easily upgrade from the Basic Plan to any of our other plans at any time. Simply contact
                our support team or use the upgrade option in your account settings to choose the plan that best fits
                your needs.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 mb-4 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                 What support is included in the Premium Plan?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                The Premium Plan offers 24/7 premium customer support, a dedicated account manager, continuous training,
                and consultations to ensure you get the most out of our software and maximize its benefits.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 mb-4 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                 Are there any hidden fees in your plans?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                No, there are no hidden fees. Our pricing is transparent and straightforward. Each plan clearly outlines
                what is included, and any additional services or customizations will be discussed upfront.
              </p>
            </mat-expansion-panel>
            <mat-expansion-panel class="py-8 mb-4 md:py-2 border-solid-purple">
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-1">
                  <div class="max:w-[15%] min:w-[15%]">
                    <mat-icon class="text-maroon text-lg md:text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
                  </div>
                  <span class="ml-2 max:w-[85%] min:w-[85%]">
                 Is a credit card accepted for the payment to purchase the software?
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="para-border mt-5 pt-2 text-justify text-zinc-500">
                Any subscription can be paid for with a credit card or any other payment option. You might be able to
                receive an invoice and pay via bank transfer or ACH if you decide to make a yearly payment. For further
                information, see our Help Center, or get in touch with us to begin the process.
              </p>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="above-footer py-12" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="m-auto text-center">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
